module.exports = __webpack_public_path__ + "menu.fd8ffb47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/menu.jpg
// module id = 8INm
// module chunks = 0